import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

// PrimeVue Aura uses '.dark-mode' selector on <html> (configured in main.js)
const STORAGE_KEY = 'theme-dark-mode'
const HTML_EL = document.documentElement

export const useThemeStore = defineStore('theme', () => {
  // ── Inicialización ─────────────────────────────────────────────────────────
  // Prioridad: localStorage > preferencia del sistema
  function getInitialDark(): boolean {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored !== null) return stored === 'true'
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  }

  const isDark = ref(getInitialDark())

  // ── Aplicar clase al <html> ─────────────────────────────────────────────────
  function apply(dark: boolean) {
    if (dark) {
      HTML_EL.classList.add('dark-mode')
    } else {
      HTML_EL.classList.remove('dark-mode')
    }
  }

  // Aplicar en el momento de inicialización del store
  apply(isDark.value)

  // ── Watch ───────────────────────────────────────────────────────────────────
  watch(isDark, (dark) => {
    apply(dark)
    localStorage.setItem(STORAGE_KEY, String(dark))
  })

  // ── Escuchar cambios del sistema mientras la app está abierta ───────────────
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    // Solo respetar el sistema si el usuario no ha fijado preferencia explícita
    if (localStorage.getItem(STORAGE_KEY) === null) {
      isDark.value = e.matches
    }
  })

  function toggle() {
    isDark.value = !isDark.value
  }

  function setDark(value: boolean) {
    isDark.value = value
  }

  return { isDark, toggle, setDark }
})
